var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhpBtnWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 40,
    viewBox: "0 0 120 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 40,
    rx: 8,
    fill: "#25D366"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 25,
    fontSize: 14,
    fontFamily: "Arial",
    fill: "#fff",
    textAnchor: "middle"
  }, "WhatsApp")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhpBtnWhatsapp);
export default __webpack_public_path__ + "static/media/whp-btn-whatsapp.98d68ecb91b1edddb24902a9950aee61.svg";
export { ForwardRef as ReactComponent };